


















































import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required, integer, minValue } from 'vuelidate/lib/validators';
import { MedTransGoConstants } from '@/util/constants';
import { ObjectFactory } from '@/config/objectFactory';
import { CompleteRequest } from '@/types/request';

@Component({
    props: {
        requestId: String,
    },
    mixins: [validationMixin],
    data() {
        return {
            appointmentDuration: '',
            noShow: null,
            additionalNotes: '',
        };
    },
    validations: {
        appointmentDuration: {
            required,
            integer,
            minValue: minValue(1),
        },
        noShow: {
            required,
        },
    },
})
export default class CompleteHomeHealthCareRequestModal extends Vue {
    private show = true;
    private async completeRequest() {
        const completeRequest: CompleteRequest = {
           startTime: this.$data.startTime,
            appointmentDuration: this.$data.appointmentDuration,
            noShow: this.$data.noShow,
            additionalNotes: this.$data.additionalNotes,
        };
        const response = await ObjectFactory.getRequestService().completeRequest(this.$props.requestId,
            completeRequest, this.$store.state.serverUrl);
        if (response.success) {
            this.$router.push({ path: MedTransGoConstants.URL_REQUESTS,
                query: {requestType: 'homeHealthCareRequest'} });
        }
    }

    private close() {
        this.$emit('close');
    }
}
